<div class="col-sm-12 close-button" mat-dialog-title>
  <mat-icon (click)="onCancel()">close</mat-icon>
</div>
<mat-dialog-content>
  <mat-label class="message">{{ 'REPORT_FORM.DUPLICATION_DIALOG.MESSAGE' | translate: { mej: mej, description: description } }}</mat-label>

  <ng-container *ngIf="isCapexActiveStage">
    <div class="capex-options-label">
      {{ 'REPORT_FORM.DUPLICATION_DIALOG.CAPEX_OPTIONS_LABEL' | translate }}
    </div>
    <mat-radio-group [(ngModel)]="selectedCapexOption" class="capex-radio-group">
      <mat-radio-button value="toMej" class="capex-radio-option">
        <div class="capex-option-text">
          <strong>{{ 'REPORT_FORM.DUPLICATION_DIALOG.CAPEX_OPTION_A' | translate }}</strong>
          <p>{{ 'REPORT_FORM.DUPLICATION_DIALOG.CAPEX_OPTION_A_DESC' | translate }}</p>
        </div>
      </mat-radio-button>
      <mat-radio-button value="keepCapex" class="capex-radio-option">
        <div class="capex-option-text">
          <strong>{{ 'REPORT_FORM.DUPLICATION_DIALOG.CAPEX_OPTION_B' | translate }}</strong>
          <p>{{ 'REPORT_FORM.DUPLICATION_DIALOG.CAPEX_OPTION_B_DESC' | translate }}</p>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onProceed()"
          [disabled]="isCapexActiveStage && !selectedCapexOption">
    {{ 'COMMON.BUTTONS.PROCEED' | translate }}
  </button>
  <button mat-raised-button class="discard-changes" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
